import { MotifContainer } from './components/motif-container';
import { MotifCssLink, type MotifCssProps } from './components/motif-css-link';
import { MotifEditorSync } from './components/motif-editor-sync';
import { MotifSections } from './components/motif-sections';

type Props = MotifCssProps & {
  /** Editor: register the rendered sections for preview/details scroll sync and show the per-section edit button. */
  withEditorSync?: boolean;
};

/**
 * Root of the Motif layout: a self-contained `bb-ww` document styled entirely by an external theme stylesheet.
 * The markup is the SAME for every theme (one universal DOM); the whole-page layout is determined purely by
 * the theme CSS — there is no per-theme layout token to store. See layout-motif/docs/bem-contract.md.
 */
export const WeddingWebsiteMotif = (props: Props) => (
  <MotifContainer editorOverlay={props.withEditorSync ? <MotifEditorSync /> : undefined}>
    {props.guest ? (
      <MotifCssLink guest guestCssHash={props.guestCssHash} />
    ) : (
      <MotifCssLink inlineCss={props.inlineCss} />
    )}
    <MotifSections />
  </MotifContainer>
);
